// Sign-in gate — the only component that knows auth exists.
//
// When auth is enabled for the environment, nothing renders until the user
// has an Entra session: signed-out users get a minimal branded screen with
// one action (Microsoft sign-in via redirect — no popup, per the app
// registration's SPA platform). When auth is disabled, this component isn't
// even mounted (see index.tsx), so the rest of the app never changes.

import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { LOGIN_REQUEST, authError } from "@/lib/auth";

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) return <>{children}</>;

  // Mid-redirect (coming back from Microsoft with a code, or heading out):
  // render nothing rather than flashing the sign-in screen.
  if (inProgress !== InteractionStatus.None) return null;

  return (
    <div className="auth-gate">
      <div className="brand">
        <span>Lennar</span>
        <span className="brand-divider" />
        <span className="brand-sub">Digital Experience</span>
      </div>
      <p className="auth-gate-blurb">
        The Digital Roadmap is available to authorized team members.
      </p>
      {authError && (
        <p className="auth-gate-error" role="alert">
          Sign-in didn&rsquo;t complete: {authError}
        </p>
      )}
      <button
        type="button"
        className="btn primary"
        onClick={() => void instance.loginRedirect(LOGIN_REQUEST)}
      >
        Sign in with Microsoft
      </button>
    </div>
  );
}
